<template lang="pug">
#pills-bet.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='pills-bet-tab')
  template(v-if="showGameResult")
    gameResult(:category="category" @getDifferentPage="getDifferentPage" @backPrev="backPrev")
  template(v-else)
    .d-lg-none
      template(v-if="platformWinlose.length > 0")
        .transaction-single.pb-2.mb-3(v-for="data in platformWinlose")
          .mb-1.text-smaller {{selectedDate}}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.category')}}
            .statement-type
              a.text-primary(href='javascript:void(0)') {{data.category}}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.bet_count')}}
            .statement-type
              a.text-primary(href='javascript:void(0)') {{data.bet_count}}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.winlose')}}
            .statement-type
              a.text-primary(:class="getColor(data.winlose)" href='javascript:void(0)' @click.stop="getMemberGameResult(data.category, selectedDate)") {{data.winlose}}
                i.fas.fa-chevron-circle-right.ml-1
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.commission')}}
            .statement-type
              a.text-primary(href='javascript:void(0)') {{data.comm}}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.turnover')}}
            .statement-type
              a.text-primary(href='javascript:void(0)') {{data.turnover}}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.turnover_valid')}}
            .statement-type
              a.text-primary(href='javascript:void(0)') {{data.valid_turnover}}
                //- i.fas.fa-chevron-circle-right.ml-1
          //- .d-flex.bg-row02
          //-   .flex-grow-1 {{$t('ui.category')}}
          //-   .font-weight-bold {{data.category}}
          //-     i.fas.fa-chevron-circle-right.ml-1.invisible
        //- .d-flex.history-single(v-for="data in platformWinlose")
        //-   .flex-grow-1
        //-     .history-type Misty
        //-     .text-secondary.history-date 2020-08-05
        //-   .ml-2.text-small
        //-     .text-right.text-success.font-weight-normal WIN:
        //-     .text-right PAYOUT:
        //-   .ml-2.text-small
        //-     .text-right.text-success.font-weight-normal 500.00
        //-     .text-right 500.00
      template(v-else)
        .text-center.text-white.my-2 {{ $t('ui.no_record') }}
        
    .d-none.d-lg-block
      .package-table.mb-0
        .row.table-row
          .col {{$t('ui.date')}}
          .col {{$t('ui.category')}}
          .col {{$t('ui.bet_count')}}
          .col {{$t('ui.winlose')}}
          .col {{$t('ui.commission')}}
          .col {{$t('ui.turnover')}}
          .col {{$t('ui.turnover_valid')}}
        template(v-if="platformWinlose.length > 0")
          .row.table-row(v-for="data in platformWinlose")
            //- .col.text-left
              .d-flex.flex-column
                div Spirit of the Lamp
                .text-smaller.text-white-50 2020-01-02
            .col {{selectedDate}}
            .col {{data.category}}
            .col {{data.bet_count}}
            .col
              a(href="javascript:void(0)" :class="getColor(data.winlose)" @click.stop="getMemberGameResult(data.category, selectedDate)") {{data.winlose}}
                i.fas.fa-chevron-circle-right.ml-1
            .col {{data.comm}}
            .col {{data.turnover}}
            .col {{data.valid_turnover}}
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
//- .statement-wrapper
  template(v-if="showGameResult")
    gameResult(:category="category" @getDifferentPage="getDifferentPage")
  template(v-else)
    .statement-mobile
      .statement-history
        template(v-if="platformData.length > 0")
          .statement-history-content(v-for="item in platformData")
            .statement-history-left
              .statement-history-date.no-uppercase  {{item.account_id}}
              .statement-history-game {{ $moment(item.working_date).format("YYYY-MM-DD") }}
            .statement-history-right
              .statement-history-id {{item.category}}                
              .statement-history-amount
                a(href="javascript:void('0')" :class="getColor(item.winlose)" @click.stop="getMemberGameResult(item.category, $moment(item.working_date).format('YYYY-MM-DD'))") {{item.winlose}}
                  i.fa-solid.fa-circle-chevron-right.ms-1 
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
    .statement-desktop
      .table-statement
        .row.table-statement-row
          .col.table-statement-col ID
          .col.table-statement-col {{$t('ui.platform')}} 
          .col.table-statement-col {{$t('ui.winlose')}} 
          .col.table-statement-col {{$t('ui.date')}} 
        template(v-if="platformData.length > 0")
          .row.table-statement-row(v-for="item in platformData")
            .col.table-statement-col.no-uppercase  {{item.account_id}}
            .col.table-statement-col {{item.category}}
            .col.table-statement-col
              a(href="javascript:void('0')" :class="getColor(item.winlose)" @click.stop="getMemberGameResult(item.category, $moment(item.working_date).format('YYYY-MM-DD'))") {{item.winlose}}
            .col.table-statement-col {{ $moment(item.working_date).format("YYYY-MM-DD") }}
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
</template>
<script>
import config from '@/config'
import gameResult from '@/component/gameResult/_gameResult.vue'
export default {
  components:{
    gameResult,
  },
  data(){
    return{
      url : "",
      path: "",
      showGameResult: false,
      category: "",
      platformWinlose: [],
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    selectedDate(){
      return this.$store.getters.settlementDate
    }
  },
  beforeDestroy(){
    this.reset()
  },
  mounted(){
    window.scroll(0, 0)
    // if(!this.reportDetails){
    //   this.showGameResult = false
    // }
    if(this.selectedDate){
      this.getPlatformWinLose(this.selectedDate)
    }else{
      this.$store.dispatch("user/settlementDate", this.$moment().subtract(12, 'h').format("YYYY-MM-DD"))
      this.getPlatformWinLose(this.$moment().subtract(12, 'h').format("YYYY-MM-DD"))
    }
  },
  methods:{
    backPrev(e){
      this.getPlatformWinLose(this.selectedDate)
      this.showGameResult = false
    },
    getPlatformWinLose(date) {
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        let working_date =  date
        this.$store
          .dispatch("user/getPlatformWinLose", { member_id, working_date, auth_token })
          .then(response => {
            if (response.success == true) {
              this.platformWinlose = response.data
              // this.$emit("showBetHistory", {
              //   data: response.data
              // })
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getColor(amount){
      if(amount > 0){
        return 'text-success'
      }else{
        return 'text-color01'
      }
    },
    getDifferentPage(e){
      this.getMemberGameResult(e.category, e.workingDate, e.pageSize, e.newPage)
    },
    getMemberGameResult(option, workingDate, page_size, page_number){
      switch(option){
        case "LIVECASINO":
          this.url = config.getGameResultLivecasino()
          this.path = "user/sLivecasinoResult"
          this.category = "LIVECASINO"
          break;

        case "SLOTS":
          this.url = config.getGameResultSlot()
          this.path = "user/sSlotResult"
          this.category = "SLOTS"
          break;

        case "SPORTSBOOK":
          this.url = config.getGameResultSb()
          this.path = "user/sSbResult"
          this.category = "SPORTSBOOK"
          break;
        default:
          break;
      }
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        let url = this.url
        let working_date = workingDate
        let sort_key= null
        let sort_type = null
        this.$store
          .dispatch("user/getMemberGameResult", { member_id, working_date, page_size, page_number, auth_token, url, sort_key, sort_type })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch(this.path, { data: response.data, size: 10, index: 1, working_date: working_date })
                .then(() => {
                  this.showGameResult = true
                  this.$emit("platformSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    reset(){
      this.showGameResult = false
    }
  }
}
</script>
<style lang="scss" scoped>
.text-color01{
  color: #FF6969 !important;
}
</style>